import {
    comMapping
} from '../../../util/Function/comMapping.js'

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: "companyName",
                label: '公司名称',
                type: "selectmore",
                width: "220px",
            },
            {
                prop: "jzjtsuosq",
                label: '即征即退所属期',
                type: "datemonth",
                valueformat: 'yyyyMM'
            },
            {
                prop: "createTime",
                label: '创建日期',
                type: "date",
                valueformat: 'yyyy-MM-dd'
            },
            {
                prop: "generateStatus",
                label: '生成状态',
                type: "select",
                width: "220px",
                selectval: [
                    {
                        label: "成功",
                        value: "1"
                    },
                    {
                        label: "部分成功",
                        value: "2"
                    },
                    {
                        label: "失败",
                        value: "3"
                    },
                    {
                        label: "生成中",
                        value: "4"
                    },
                ]
            },
        ],
        searchdata: {
            companyName: [],
            jzjtsuosq: "",
            createTime: [],
            generateStatus: "",
        },
        headData: [
            {
                title: "创建日期",
                prop: "createTime",
                width: 80,
                custom: true
            },
            {
                title: "即征即退所属期",
                prop: "jzjtsuosq",
                width: 100,
                custom: true
            },
            {
                title: "公司代码",
                prop: "companyCode",
                width: 80,
                custom: true
            },
            {
                title: "公司名称",
                prop: "companyName",
                width: 80,
                custom: true
            },
            {
                title: "生成状态",
                prop: "generateStatus",
                width: 80,
                custom: true
            },
            {
                title: "成功条数",
                prop: "sucCount",
                width: 80,
                custom: true
            },
            {
                title: "失败条数",
                prop: "failCount",
                width: 80,
                custom: true
            },
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },
    }
    return obj
}
